import { useCallback, useReducer } from 'react';

export default function useTabState() {
  const [tabState, dispatch] = useReducer(reducer, {});

  const setTabState = useCallback(
    function(payload) {
      dispatch({ type: 'SET_TAB_STATE', payload });
    },
    [dispatch]
  );

  const concatMoreEncounters = useCallback(
    function(payload) {
      dispatch({ type: 'CONCAT_MORE_ENCOUNTERS', payload });
    },
    [dispatch]
  );

  return {
    tabState,
    setTabState,
    concatMoreEncounters
  };
}

function reducer(state, action) {
  const { type, payload } = action;
  if (type === 'SET_TAB_STATE') {
    const { epochs } = payload;
    if (epochs) {
      return { epochs };
    }
    const { encountersWithAppointments: encounters, page, totalSize: totalEncounters } = payload;
    return { encounters, page, totalEncounters };
  }
  if (type === 'CONCAT_MORE_ENCOUNTERS') {
    const { encountersWithAppointments: encounters, page, totalSize: totalEncounters } = payload;
    return { ...state, encounters: [...state.encounters, ...encounters], page, totalEncounters };
  }
  return state;
}
